import React, { useEffect, useRef, useState } from 'react'
import abcjs, { synth } from 'abcjs';

export default function AbcAudioPlayer({ visualObj }) {
  const renderEl = useRef(null)

  const initSyntControl = () => {
    if (!renderEl.current) return

    const synthControl = new abcjs.synth.SynthController();
    synthControl.load(
      renderEl.current,
      {}, //cursorControl
      {
        displayLoop: true,
        displayRestart: true,
        displayPlay: true,
        displayProgress: true,
        displayWarp: true
      }
    );
    return synthControl;
  }

  const initAudio = () => {
    var myContext = new AudioContext();
    const synthControl = initSyntControl();

    const synth = new abcjs.synth.CreateSynth();

    synth.init({
      audioContext: myContext,
      millisecondsPerMeasure: 500,
      visualObj: visualObj[0],
    }).then((results) => {
      synthControl?.setTune(visualObj[0], false, {})
    }).catch(function (reason) {
      console.log(reason)
    });
  }

  useEffect(() => {
    if (!visualObj || !renderEl.current) return
    initAudio()
  }, [renderEl.current, visualObj])


  return (
    <>
      <div className="audio-player-container" ref={renderEl} />
    </>
  )
}


